module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Bra gjort","subtitle":"Du har nådd dagsmålet ditt","text":"Nyt dine daglige<br> hjernedates","streak":"Du  er på en {0} dagers streak"},"en":{"title":"Great job","subtitle":"You finished your daily goal!","text":"Enjoy your daily<br> brain dates","streak":"You are on a {0} day streak"}}')
  delete Component.options._Ctor
}
